import { FormikErrors } from 'formik'
import { useCallback } from 'react'
import { FiltersFormModel } from '..'

type Props = {
  isRescheduling: boolean
}

export function useHandlers(props: Props) {
  const { isRescheduling } = props

  const validate = useCallback(
    (values: FiltersFormModel) => {
      const { startDate, endDate, startTime, endTime, duration } = values

      const errors: FormikErrors<FiltersFormModel> = {}

      if (startDate === null) errors.startDate = 'Required'
      if (endDate === null) errors.endDate = 'Required'
      if (startDate !== null && endDate !== null) {
        if (startDate > endDate) {
          errors.startDate = 'Invalid Range'
          errors.endDate = 'Invalid Range'
        }
      }

      if (startTime !== null && endTime !== null) {
        if (startTime >= endTime) {
          errors.startTime = 'Invalid Range'
          errors.endTime = 'Invalid Range'
        }
      }
      if (!isRescheduling) {
        if (duration === 0 || duration === '') {
          errors.duration = 'Required'
        } else if (duration > 1440) {
          errors.duration = 'Must be less than 24 hours (1440 minutes)'
        }
      }

      return errors
    },
    [isRescheduling],
  )

  return {
    validate,
  }
}
